<template>
  <div class="usersDetail">
    <div class="userInfoTop">
      <div class="user_left">
        <img :src="formData.headPortrait" alt="" />
        <div class="userInfo">
          <h3 v-if="formData.userType == '0'">{{ formData.name }}</h3>
          <h3 v-if="formData.userType == '1'">{{ formData.companyName }}</h3>
          <div class="stateBox">
            <span class="phone">{{ formData.phone }}</span>
            <span class="state stateQ" v-if="formData.state == '1'">启用</span>
            <span class="state stateT" v-if="formData.state == '0'">停用</span>
          </div>
        </div>
      </div>
      <div class="user_right">
        <!--        <div style="color: #17757a" @click="editItem">编辑</div>-->
        <el-button type="success" plain @click="backSuperior">返回上级</el-button>
      </div>
    </div>
    <div class="reasonState" v-if="formData.rejectReason">
      <i class="el-icon-warning"></i>
      <span>{{ formData.rejectReason }}</span>
    </div>
    <div class="userInfoBom">
      <el-form label-position="right" label-width="100px">
        <div class="basicInfoBox">
          <div class="basicInfo">
            <div class="title"><span></span><span>基本信息</span></div>
          </div>
          <!-- 个人 -->
          <div class="infoDetail" v-if="formData.userType == 0">
            <div>
              <el-form-item label="所在地点：">
                <span>{{ formData.userCountry }}</span>
                <span v-if="formData.userCountry && formData.userProvince">-</span>
                <span>{{ formData.userProvince }}</span>
                <span v-if="formData.userProvince && formData.userCity">-</span>
                <span>{{ formData.userCity }}</span>
              </el-form-item>
              <el-form-item label="邮箱：">{{ formData.mail }}</el-form-item>
              <el-form-item label="微信号：">{{ formData.weChat }}</el-form-item>
            </div>
            <div>
              <el-form-item label="真实姓名：">{{ formData.name }}</el-form-item>
              <el-form-item label="联系电话：">{{ formData.phone }}</el-form-item>
              <el-form-item label="擅长领域：" style="color: rgba(23, 117, 122, 0.85)">{{
                formData.technique
              }}</el-form-item>
            </div>
          </div>
          <!-- 企业 -->
          <div class="infoDetail" v-if="formData.userType == 1">
            <div>
              <el-form-item label="企业名称：">{{ formData.companyName }}</el-form-item>
              <el-form-item label="所在地点：">
                <span>{{ formData.userCountry }}</span>
                <span v-if="formData.userCountry && formData.userProvince">-</span>
                <span>{{ formData.userProvince }}</span>
                <span v-if="formData.userProvince && formData.userCity">-</span>
                <span>{{ formData.userCity }}</span>
              </el-form-item>
              <el-form-item label="邮箱：">{{ formData.mail }}</el-form-item>
              <el-form-item label="感兴趣领域：">{{ formData.interested }}</el-form-item>
            </div>
            <div>
              <el-form-item label="联系电话：">{{ formData.phone }}</el-form-item>
              <el-form-item label="联系人：">{{ formData.contacts }}</el-form-item>
              <el-form-item label="擅长领域：" style="color: rgba(23, 117, 122, 0.85)">{{
                formData.technique
              }}</el-form-item>
            </div>
          </div>
        </div>
        <!-- 个人 -->
        <div class="identityBox" v-if="formData.userType == 0">
          <div class="basicInfo identity">
            <div class="title"><span></span><span>身份认证</span></div>
          </div>
          <div class="infoDetail">
            <div>
              <el-form-item label="身份证正面：">
                <!-- <img src="../../../assets/images/Group 2424.png" alt="" /> -->
                <!-- <img :src="formData.idCardFront" alt="" /> -->
                <el-image
                  style="width: 124px; height: 84px"
                  :src="formData.idCardFront"
                  :preview-src-list="idCardFrontList"
                >
                </el-image>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="身份证反面：">
                <!-- <img src="../../../assets/images/Group 2429.png" alt="" /> -->
                <!-- <img :src="formData.idCardReverse" alt="" /> -->
                <el-image
                  style="width: 124px; height: 84px"
                  :src="formData.idCardReverse"
                  :preview-src-list="idCardReverseList"
                >
                </el-image>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 企业 -->
        <div class="identityBox" v-if="formData.userType == 1">
          <div class="basicInfo identity">
            <div class="title"><span></span><span>信息认证</span></div>
          </div>
          <div class="infoDetail">
            <div>
              <el-form-item label="营业执照：">
                <!-- <img src="../../../assets/images/yinyezhizhao.png" alt="" /> -->
                <img :src="formData.businessLicense" alt="" />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="accountBox">
          <div class="basicInfo account">
            <div class="title"><span></span><span>账户信息</span></div>
          </div>
          <div class="infoDetail account row">
            <el-form-item label="开户行支行："> {{ formData.openingBank }} </el-form-item>
            <el-form-item label="银行卡号："> {{ formData.bankCar }} </el-form-item>
          </div>
        </div>
        <div class="commitTime">
          <span>提交时间：{{ formData.subTime }}</span>
          <span>新增时间：{{ formData.createTime }}</span>
        </div>
      </el-form>
    </div>
    <div class="operation">
      <el-button type="primary" plain @click="approved">审核通过</el-button>
      <el-button type="primary" plain @click="auditingNo">审核不通过</el-button>
      <el-button type="primary" plain @click="backSuperior">返回上级</el-button>
    </div>
    <!-- 审核不通过弹窗 -->
    <el-dialog :visible.sync="auditingNoDialogVisible" width="40%" :before-close="handleClose">
      <div class="auditingNo">
        <div class="title"><span></span><span>审核不通过</span></div>
      </div>
      <div style="padding: 50px 50px 0 40px">
        <el-form
          label-position="left"
          label-width="100px"
          :model="auditingNoForm"
          :rules="auditingNoRules"
        >
          <div style="display: flex">
            <el-form-item label="驳回理由：" prop="rejectionReason">
              <el-select
                v-model="auditingNoForm.rejectionReason"
                placeholder="请选择"
                @change="rejectionReasonChange"
                clearable
                :disabled="auditingDisabled"
              >
                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="info">
                <el-radio
                  :label="1"
                  :disabled="rejectionDisabled"
                  @click.native="pendingRes($event)"
                  >自定义理由</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="驳回理由：" v-if="info == 1">
            <el-input
              v-model="auditingNoForm.rejectionReason"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="auditingNoFn">保 存</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 编辑用户弹窗 -->
    <el-dialog
      title="编辑用户"
      :visible.sync="dialogVisibleedit"
      width="40%"
      :before-close="edithandleClose"
    >
      <div style="padding: 30px">
        <el-form
          ref="usersForm"
          :rules="usersFormRules"
          :model="usersForm"
          label-position="right"
          label-width="100px"
        >
          <!-- 1 -->
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="用户类型：" prop="userType">
              <el-radio-group v-model="usersForm.userType" aria-disabled="true">
                <el-radio label="0" disabled>个人用户</el-radio>
                <el-radio label="1" disabled>企业用户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否启用：" style="width: 44%">
              <el-switch
                v-model="usersForm.state"
                active-color="rgba(23, 117, 122, 1)"
                inactive-color="#DCDFE6"
                active-value="1"
                inactive-value="0"
                active-text="启用"
                :width="60"
              >
              </el-switch>
            </el-form-item>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item
              label="用户名："
              prop="name"
              v-if="usersForm.userType == '0' || !usersForm.userType"
            >
              <el-input v-model="usersForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item
              label="企业名称："
              prop="companyName"
              v-if="usersForm.userType == '1' || !usersForm.userType"
            >
              <el-input v-model="usersForm.companyName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="企业名称：" prop="companyName" v-if="usersForm.userType == '1'">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.companyName"
                  placeholder="请输入"
                  style="width: 187px"
                ></el-input>
                <span style="color: #f56c6c; line-height: 22px" v-if="!usersForm.companyName">{{
                  msgCompanyTips
                }}</span>
              </div>
            </el-form-item>
            <div style="display: flex; flex-direction: column; width: 44%">
              <el-form-item label="性别：" prop="gender">
                <el-radio-group v-model="usersForm.gender">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="英文名：">
              <div style="display: flex; flex-direction: column">
                <el-input v-model="usersForm.nameEnglish" placeholder="请输入"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="邮箱：" prop="mail" style="width: 44%">
              <el-input
                v-model="usersForm.mail"
                placeholder="请输入"
                style="width: 187px"
              ></el-input>
            </el-form-item>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="联系电话：" prop="phone">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.phone"
                  placeholder="请输入"
                  maxlength="11"
                  style="width: 187px"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="微信号：" style="margin-left: 40px; width: 44%">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.weChat"
                  placeholder="请输入"
                  maxlength="11"
                  style="width: 187px"
                ></el-input>
              </div>
            </el-form-item>
          </div>
          <div style="display: flex; flex-direction: column; margin-bottom: 8px">
            <el-form-item
              label="所在地区："
              prop="userCountry"
              :rules="[
                { required: true, message: '请输入', trigger: 'blur' },
                {
                  validator: (rules, value, callback) =>
                    validatorEnumsLabel(rules, value, callback),
                  trigger: 'blur',
                  required: true
                }
              ]"
            >
              <CascaderArea
                :country="usersForm.userCountry"
                :province="usersForm.userProvince"
                :city="usersForm.userCity"
                class="CascaderArea"
                @searchArae="searchAraeUsers"
              />
            </el-form-item>
            <span
              style="color: #f56c6c; line-height: 22px; margin-left: 100px"
              v-if="!usersForm.userCountry || !usersForm.userProvince || !usersForm.userCity"
              >{{ msgAddressTips }}</span
            >
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUsers">保 存</el-button>
        <el-button @click="edithandleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserById, agree, reject, rejectionType, update } from '@/api/jingyiUsers'
import CascaderArea from '@/components/CascaderArea.vue'
import DicButton from '@/components/DicButton.vue'
export default {
  components: {
    CascaderArea
  },
  data() {
    return {
      auditingDisabled: false, //控制驳回理由下拉状态
      rejectionDisabled: false, //控制自定义理由状态
      auditingNoDialogVisible: false, //审核不通过弹窗显示
      options: [], //驳回理由数据
      radio: 0, //驳回理由
      //审核不通过表单数据
      info: 0, //是否显示自定义驳回理由
      auditingNoForm: {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      },
      // 展示数据表单
      formData: {
        bankCar: '', //银行卡号
        businessLicense: '', //营业执照
        companyName: '', //企业名称
        contacts: '', //联系人
        createName: '', //创建人名字
        createTime: '', //创建时间/提交时间
        headPortrait: '', //头像
        idCardFront: '', //身份证正面
        idCardReverse: '', //身份证反面
        interested: '', //感兴趣领域
        mail: '', //邮件
        name: '', //姓名
        openingBank: '', //开户行支行
        phone: '', //联系电话
        rejectReason: '', //拒绝理由
        state: '', //目前状态: 0 停用 1启用
        technique: '', //擅长领域
        updateName: '', //修改人名字
        updateTime: '', //修改时间
        userCountry: '', //所在国家
        userProvince: '', //所在省份
        userCity: '', //所在城市
        userCode: '', //菁亿用户编号
        reviewCode: '', //审核id
        userType: '', //用户类型：0 个人用户 1 企业用户
        weChat: '' //微信号
      },
      //审核不通过表单校验
      auditingNoRules: {
        rejectionReason: [{ required: true, message: '请选择驳回理由', trigger: 'change' }]
      },
      dialogVisibleedit: false, //编辑用户弹窗
      //添加用户表单
      usersForm: {
        userCode: this.id, //用户编码
        userType: null, //用户类型：0 个人用户 1 企业用户
        companyName: '', //企业名称
        name: '', //用户名
        phone: '', //联系电话
        state: '', //是否启用: 0 停用 1启用
        nameEnglish: '', //英文名
        weChat: '', //微信号
        userCountry: '', //所在国家
        userProvince: '', //所在省份
        userCity: '', //所在城市
        mail: '', //邮箱
        gender: '' //性别
      },
      usersFormRules: {
        userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确联系电话', trigger: 'blur' }
        ],
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'change' }],
        mail: [{ required: true, message: '请输入邮箱', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }]
      },
      msgAddressTips: '',
      idCardFrontList: [],
      idCardReverseList: []
    }
  },
  computed: {
    // 用户唯一id
    id() {
      return this.$route.query.userCode
    },
    // 审核唯一id
    reviewCode() {
      return this.$route.query.reviewCode
    }
  },
  created() {
    this.getUserById()
    this.getRejectionType()
  },
  methods: {
    // 控制驳回理由
    pendingRes(event) {
      if (event.target.tagName === 'INPUT') {
        let id = event.target.value
        if (this.info != id) {
          this.auditingDisabled = true
          this.auditingNoRules.rejectionReason[0].required = false
          this.auditingNoRules.rejectionReason[0].message = ''
        } else {
          this.auditingDisabled = false
          this.auditingNoRules.rejectionReason[0].required = true
          this.auditingNoRules.rejectionReason[0].message = '请选择驳回理由'
          this.info = 0
        }
      }
    },
    //选中审核不通过改变事件
    rejectionReasonChange(val) {
      if (val) {
        this.rejectionDisabled = true
      } else {
        this.rejectionDisabled = false
      }
    },
    // 驳回理由
    async getRejectionType() {
      const { data } = await rejectionType({ type: '023' })
      if (data.resultCode == 200) {
        this.options = data.data
      }
    },
    // 审核通过
    async approved() {
      const { data } = await agree({ reviewCodes: this.reviewCode })
      if (data.resultCode == 200) {
        this.$message.success(data.message)
        this.getUserById()
        this.auditingNoForm = {}
        this.$router.push({
          path: '/jingyiUsers'
        })
      }
    },
    // 打开审核不通过弹窗
    auditingNo() {
      this.auditingNoDialogVisible = true
    },
    // 关闭审核不通过弹窗
    handleClose() {
      this.auditingNoDialogVisible = false
      this.info = 0
      this.auditingDisabled = false
      this.rejectionDisabled = false
      this.auditingNoForm = {
        rejectionReason: '', //驳回理由
        rejectionType: '', //驳回理由类型（自定义）
        reviewCode: '' //审核编号审核编号
      }
      this.auditingNoRules.rejectionReason[0].require = false
      this.getUserById()
    },
    // 审核不通过弹窗保存
    async auditingNoFn() {
      this.auditingNoForm.reviewCode = this.reviewCode
      const { data } = await reject(this.auditingNoForm)
      if (data.resultCode == 200) {
        this.$message.success(data.message)
        this.auditingNoDialogVisible = false
        this.info = 0
        this.auditingDisabled = false
        this.rejectionDisabled = false
        this.auditingNoRules.rejectionReason[0].require = false
        this.auditingNoForm = {
          rejectionReason: '', //驳回理由
          rejectionType: '', //驳回理由类型（自定义）
          reviewCode: '' //审核编号审核编号
        }
        this.getUserById()
        this.$router.push({
          path: '/jingyiUsers'
        })
      }
    },
    // 返回上级
    backSuperior() {
      this.$router.push({
        path: '/jingyiUsers'
      })
    },
    // 查看用户修改审核信息详情
    async getUserById() {
      const { data } = await getUserById({ reviewCode: this.reviewCode })
      if (data.resultCode == 200) {
        this.formData = data.data
        this.usersForm.userType = data.data.userType
        this.usersForm.name = data.data.name
        this.usersForm.phone = data.data.phone
        this.usersForm.state = data.data.state
        this.usersForm.companyName = data.data.companyName
        this.usersForm.weChat = data.data.weChat
        this.usersForm.gender = data.data.gender
        this.usersForm.nameEnglish = data.data.nameEnglish
        this.usersForm.userCountry = data.data.userCountry
        this.usersForm.userProvince = data.data.userProvince
        this.usersForm.userCity = data.data.userCity
        this.usersForm.mail = data.data.mail

        this.idCardFrontList.push(data.data.idCardFront)
        this.idCardReverseList.push(data.data.idCardReverse)
      }
    },
    //编辑 弹框显示
    editItem() {
      this.dialogVisibleedit = true
    },
    // 编辑 弹窗关闭
    edithandleClose() {
      this.dialogVisibleedit = false
      this.getUserById()
    },
    //编辑
    editUsers() {
      this.$refs.usersForm.validate(async (valid) => {
        if (valid) {
          this.usersForm.userCode = this.id
          const { data } = await update(this.usersForm)
          if (data.resultCode == 200) {
            this.$message.success(data.message)
            this.dialogVisibleedit = false
            this.getUserById()
          }
        }
      })
    },
    // 弹窗选择所在地区赋值
    searchAraeUsers(val) {
      this.usersForm.userCountry = val.country
      this.usersForm.userProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.usersForm.userCity = val.city
      }
      if (val) {
        this.msgAddressTips = ''
      }
    },
    //所在地区校验
    validatorEnumsLabel(rules, value, callback) {
      if (!this.usersForm.userCountry || !this.usersForm.userProvince) {
        this.msgAddressTips = '请选择所在地区'
      } else {
        this.msgAddressTips = ''
        callback()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-input__inner {
  border: none;
}
.usersDetail {
  font-family: PingFang SC;
}
.userInfoTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  .user_left {
    font-family: PingFang SC;
    display: flex;
    justify-content: space-between;
    img {
      width: 88px;
      height: 88px;
      margin-right: 10px;
      border-radius: 4px;
    }
    .userInfo {
      padding: 4px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h3 {
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        text-align: left;
        color: rgba(26, 31, 51, 1);
      }
      .stateBox {
        display: flex;
        align-items: center;
      }
      .phone {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.6px;
        text-align: left;
        color: rgba(51, 51, 51, 1);
      }
      .state {
        width: 32px;
        height: 18px;
        border-radius: 9px;
        font-size: 10px;
        margin-left: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .stateQ {
        background: #f0f9eb;
        color: #67c23a;
      }
      .stateT {
        background: #f4f4f5;
        color: #333;
      }
    }
  }
  .user_right {
    display: flex;
    align-items: center;
    div {
      margin-right: 40px;
      cursor: pointer;
    }
    .el-button--success.is-plain {
      color: rgba(23, 117, 122, 1);
      background: #fff;
      border-color: rgba(23, 117, 122, 1);
    }
  }
}
.reasonState {
  margin-top: 10px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid rgba(250, 80, 80, 1);
  background: rgba(250, 80, 80, 0.15);
  border: 1px solid rgba(250, 80, 80, 1);
  color: rgba(250, 80, 80, 1);
  font-size: 14px;
  span {
    padding-left: 6px;
  }
}
.userInfoBom {
  margin-top: 14px;
  background: #fff;
  padding: 20px 20px 40px 20px;
  border-radius: 10px;
  .title {
    display: flex;
    align-items: center;
    span:nth-child(1) {
      display: block;
      width: 4px;
      height: 20px;
      background: rgba(23, 117, 122, 1);
      border-radius: 4px;
      margin-right: 6px;
    }
    span:nth-child(2) {
      font-size: 16px;
      font-weight: 500;
      line-height: 22.4px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .infoDetail {
    padding: 20px 50px;
    display: flex;
    img {
      width: 124px;
      height: 84px;
    }
    div {
      width: 50%;
    }
    .el-form-item {
      font-size: 14px;
      font-weight: 400;
      line-height: 19.6px;
      color: rgba(26, 31, 51, 1);
    }
  }
  .account {
    display: flex;
    flex-direction: column;
  }
  .commitTime {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: rgba(153, 153, 153, 1);
    padding: 10px 0 0 50px;
    span {
      padding: 6px 0;
    }
  }
}
.operation {
  padding: 20px 0;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  .el-button--primary:nth-child(2) {
    color: rgba(23, 117, 122, 1) !important;
    background: #fff !important;
    border-color: rgba(23, 117, 122, 1) !important;
    margin-right: 20px;
  }
  .el-button--primary:nth-child(3) {
    color: rgba(23, 117, 122, 1) !important;
    background: #fff !important;
    border-color: rgba(23, 117, 122, 1) !important;
    margin-right: 20px;
  }
  .el-button--primary {
    margin-right: 20px;
  }
  .el-button--primary:active {
    background: rgba(23, 117, 122, 1) !important;
    color: #fff !important;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
.auditingNo {
  .title {
    display: flex;
    align-items: center;
  }

  span:nth-child(1) {
    display: block;
    width: 4px;
    height: 20px;
    background: rgba(23, 117, 122, 1);
    border-radius: 4px;
    margin-right: 6px;
  }
  span:nth-child(2) {
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    color: rgba(51, 51, 51, 1);
  }
}
::v-deep .el-radio__inner {
  border: 1px solid rgba(23, 117, 122, 1);
}
::v-deep .el-dialog__footer {
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
.row {
  display: flex !important;
  flex-direction: row !important;
}
</style>
